/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lots_Filter_All_GradesInputs */

const vi_sl_lots_filter_all_grades = /** @type {(inputs: Sl_Lots_Filter_All_GradesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả phân loại`)
};

/**

* @param {Sl_Lots_Filter_All_GradesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lots_filter_all_grades = /** @type {((inputs?: Sl_Lots_Filter_All_GradesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lots_Filter_All_GradesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lots_filter_all_grades(inputs)
});